import "./Location.css";

const Location = () => {
  return (
    <section className="location">
      <div className="location__content">
        <div className="location__info">
          <div className="location__eyebrow">
            <span className="location__icon">⌖</span>
            <span>OUR OFFICE</span>
          </div>

          <h2>Delhi, India</h2>

          <p>
            Our innovation hub for product development and data strategy is
            situated in Delhi.
          </p>

          {/* <h2>Get in Touch</h2> */}

<p>
   ➤ General Enquiries:{" "}
  <a href="mailto:hi@xyncely.com">hi@xyncely.com</a>
</p>

<p>
   ➤ Sales Enquiries:{" "}
  <a href="mailto:sales@xyncely.com">sales@xyncely.com</a>
</p>

<p>
   ➤ HypeX:{" "}
  <a href="mailto:hype@hypex.events">hype@hypex.events</a>
</p>

<p>
   ➤ Phone:{" "}
  <a href="tel:+918448214848">+91 84482 14848</a>
</p>

        </div>
      </div>
    </section>
  );
};

export default Location;